/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { OnboardingTable, PrimaryButton } from "../../components";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import { useOnboardings } from "../../store/useOnboardings";

function OnboardingScreen() {
  /** Hooks */
  const navigate = useNavigate();
  const { getAllOnboardings, allOnboardings } = useOnboardings();

  /** Callbacks */
  const addOnboarding = () => navigate("/add-onboarding");

  useEffect(() => {
    getAllOnboardings();
  }, []);

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Onboardings
        </h1>
        <PrimaryButton
          onClick={addOnboarding}
          label="Add new Onboarding screen"
          className="h-10"
        />
      </div>
      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        {!allOnboardings?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no Onboarding created yet.
          </p>
        ) : (
          <OnboardingTable />
        )}
      </div>
    </div>
  );
}

export default withProtectedRoute(OnboardingScreen);
